<template>
  <div>
    <v-form>
      <v-layout row wrap>

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">Alış Fatura Bilgileri</span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm4 md4>
                    <v-text-field hide-details="" v-model="val.FaturaBilgileri.AlisFaturaNo" label="Alış Fatura No"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>

                    <tarihim :etiket="'Alış Fatura Tarihi'" v-bind:defaultvalue="'no'" v-bind:value="val.FaturaBilgileri.AlisFaturaTarihi"
                      v-model="val.FaturaBilgileri.AlisFaturaTarihi"></tarihim>
                  </v-flex>

                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">Özel Bilet Açıklama</span>
            </v-card-title>
          </v-card>
        </v-flex>


        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.EmployeeId" label="Employee ID"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.DepartmentId" label="Depart. No"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.CostCenter" label="Cost Center"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.ClientId" label="Client ID"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.DkNumber" label="DK Number"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.WwId" label="WW ID"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.BusinessUnit" label="Business Unit"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.CompanyCode" label="Comp. Code"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.SiteCode" label="Site Code"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.PurposeOt" label="Purpose OT"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.PcNumber" label="PC Number"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.NoHotelBc" label="NO Hotel BC"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.TripApprover" label="Trip Approver"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row="" wrap="">

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">MIL Kodu</span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.MilKodu.MilKoduOde" label="MIL Kodu (Ödeyen)-1"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.MilKodu.MilKoduYolcu" label="MIL Kodu (Yolcu)"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" type="Number" v-model="val.TanimBilgileri.MilKodu.MilAdet" label="MIL Adet"></v-text-field>
                  <parainput :etiket="'MIL Tutar'" v-model="val.TanimBilgileri.MilKodu.MilTutar" :autocomplete="'autocomplete'"></parainput>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>


        <v-layout row="" wrap="">


        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">Bilet Açıklama</span>
            </v-card-title>
          </v-card>
        </v-flex>

          <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
            <v-layout justify-space-between column>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama1" label="1"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama2" label="2"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama3" label="3"></v-text-field>
            </v-layout>
           </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

  <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
            <v-layout justify-space-between column>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama4" label="4"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama5" label="5"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama6" label="6"></v-text-field>
            </v-layout>
           </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
  <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>            <v-layout justify-space-between column>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama7" label="7"></v-text-field>
            </v-layout>
</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>        </v-layout>



        <v-layout row="" wrap="">


        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">T.C Kimlik No</span>
            </v-card-title>
          </v-card>
        </v-flex>

<v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>                  <v-layout justify-space-between column>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo1" label="T.C. Kimlik No (Yolcu)"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo2" label="T.C. Kimlik No (Ödeyen)"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo3" label="T.C. Kimlik No (Rez. Veren)"></v-text-field>
            </v-layout>
</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
<v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>              <v-layout justify-space-between column>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo4" label="T.C. Kimlik No (Extra 1)"></v-text-field>
              <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo5" label="T.C. Kimlik No (Extra 2)"></v-text-field>
            </v-layout>
</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
          <!-- <div class="flex md1">
            <v-btn color="info" @click.native="tcdialog = true"> Yeni
              <v-icon>add</v-icon>
            </v-btn>
          </div> -->
        </v-layout>

        <v-layout row="" wrap="">

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">Ayrıntılı Bilet Bilgileri</span>
            </v-card-title>
          </v-card>
        </v-flex>

          <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
            <v-layout justify-space-between column>
              <v-text-field hide-details="" mask="NNNNNNNNNNNNNNNNNNNNNNNN" v-model="val.NotlarBilgileri.MarketCode"
                label="Market Code"></v-text-field>
              <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.TicketSuffix" label="Ticket No Suffix"></v-text-field>
              <v-text-field hide-details="" mask="NNNNNNNNNNN" v-model="val.NotlarBilgileri.VendorNumber" label="Wendor Number"></v-text-field>
              <v-text-field hide-details="" mask="NN" v-model="val.NotlarBilgileri.ReasonCode" label="Reason Code"></v-text-field>
              <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.CRSGDS" label="CRS-GDS"></v-text-field>
            </v-layout>
</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

          <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>                 <v-layout justify-space-between column>
              <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.SubPruductCode" label="Sub-Product Code"></v-text-field>
              <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Tour Code" v-model="val.NotlarBilgileri.TourCode"></v-text-field>
              <v-checkbox label="Ticket Type Indicator" v-model="val.NotlarBilgileri.TicketTypeInd" hide-details=""></v-checkbox>


            </v-layout>
</v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        </v-layout>



    </v-form>
  </div>
</template>

<script>
  import parainput from '@/components/app/customcomp/parainput.vue'
  import tarihim from "@/components/app/customcomp/tarihim.vue"



  export default {
    props: ["value"],
    components: {
      parainput,
      tarihim

    },
    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    data() {
      return {

      }
    },

    watch: {

    },
    methods: {


    },


  }
</script>